



















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class SmsAlerts extends Vue {
	@Prop({ type: Array, required: true })
	public readonly smsMessages!: any[];

	public fields = [
		{ key: 'created_at', label: 'Time Sent', sortable: true },
		{ key: 'delivery_status', label: 'Delivery Status', sortable: true },
	];
}
